<template>
  <div class="loading_container">
    <div class="alert alert-danger m-5 text-center">
      Página não encontrada
      <p class="text-center">
        <a href="/" class="btn mt-2">
          <i class="fa fa-arrow-left" /> Voltar para o Dashboard</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundPage",

  created() {
    this.$store.commit("setActiveSection", "");
    this.$store.commit("setActiveProjectList", null);
    this.$store.commit("setLoading", false);
  },

  components: {},

  data() {
    return {};
  },

  methods: {},
};
</script>
